/** Networks a user connects through the support bot: the account id is machine-verified, never typed. */
export const MESSENGER_NETWORKS = ['telegram', 'vk'] as const;
export type MessengerNetwork = (typeof MESSENGER_NETWORKS)[number];

export const isMessengerNetwork = (value: unknown): value is MessengerNetwork =>
  (MESSENGER_NETWORKS as readonly unknown[]).includes(value);

export interface MessengerLink {
  /** Numeric account id in that network, as a string. */
  id: string;
  username: string | null;
  /** First and last name in that network: display only. */
  name: string | null;
  connectedAt: string | null;
}

export type MessengerLinks = Record<MessengerNetwork, MessengerLink | null>;

export const emptyMessengerLinks = (): MessengerLinks => ({ telegram: null, vk: null });

/**
 * The business-card handle a connected account stands for. A Telegram without a username has no public link, so
 * it writes none; a VK page always opens by `id<N>`.
 */
export function messengerContactValue(
  network: MessengerNetwork,
  account: { id: string; username: string | null },
): string | null {
  switch (network) {
    case 'telegram':
      return account.username || null;
    case 'vk':
      return account.username || `id${account.id}`;
  }
}
